import { render, staticRenderFns } from "./IconPlus.vue?vue&type=template&id=229524aa&functional=true&"
import script from "./IconPlus.vue?vue&type=script&lang=js&"
export * from "./IconPlus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports